"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMateriasTreeView = exports.getTurmasTreeView = exports.getTurmaTreeView = exports.getSerieTreeView = exports.getCursoTreeView = void 0;
const enums_1 = require("../enums");
const getCursoTreeView = ({ type, cursos, idCurso, }) => {
    if (!idCurso)
        return type == enums_1.EUserType.Professor ? cursos[0] : undefined;
    return cursos.find((f) => f.id == parseInt(idCurso, 10));
};
exports.getCursoTreeView = getCursoTreeView;
const getSerieTreeView = ({ type, cursos, idSerie, idCurso, }) => {
    var _a;
    if (idSerie && idCurso) {
        const cursoSelecionado = cursos.find((f) => f.id == parseInt(idCurso, 10));
        if (cursoSelecionado) {
            const serieSelecionada = (_a = cursoSelecionado.series) === null || _a === void 0 ? void 0 : _a.find((f) => f.id == parseInt(idSerie));
            if (serieSelecionada)
                return serieSelecionada;
        }
    }
    return type == enums_1.EUserType.Professor && cursos[0].series != undefined ? cursos[0].series[0] : undefined;
};
exports.getSerieTreeView = getSerieTreeView;
const getTurmaTreeView = ({ type, cursos, idTurma, idSerie, idCurso, }) => {
    var _a, _b;
    let cursoSelecionado = undefined;
    if (idCurso) {
        cursoSelecionado = cursos.find((f) => f.id == parseInt(idCurso, 10));
    }
    let serieSelecionada = undefined;
    if (idSerie && cursoSelecionado) {
        serieSelecionada = (_a = cursoSelecionado.series) === null || _a === void 0 ? void 0 : _a.find((f) => f.id == parseInt(idSerie));
    }
    if (idTurma && serieSelecionada) {
        const turmaSelecionada = (_b = serieSelecionada.turmas) === null || _b === void 0 ? void 0 : _b.find((f) => f.id == parseInt(idTurma, 10));
        if (turmaSelecionada)
            return turmaSelecionada;
    }
    if (serieSelecionada && serieSelecionada.turmas) {
        return serieSelecionada.turmas[0];
    }
    if (type != enums_1.EUserType.Professor)
        return undefined;
    const series = cursos[0].series;
    if (series == undefined)
        return undefined;
    const serie = series[0];
    return serie.turmas != undefined ? serie.turmas[0] : undefined;
};
exports.getTurmaTreeView = getTurmaTreeView;
const getTurmasTreeView = ({ cursos }) => {
    const turmas = [];
    cursos.map((curso) => {
        var _a;
        ((_a = curso.series) !== null && _a !== void 0 ? _a : []).map((serie) => {
            var _a, _b;
            if (((_a = serie.turmas) !== null && _a !== void 0 ? _a : []).length > 0) {
                turmas.push(...((_b = serie.turmas) !== null && _b !== void 0 ? _b : []));
            }
        });
    });
    return turmas;
};
exports.getTurmasTreeView = getTurmasTreeView;
const getMateriasTreeView = (serie, turma) => {
    var _a;
    const materias = [];
    if (turma && turma.materias) {
        return turma.materias;
    }
    ((_a = serie === null || serie === void 0 ? void 0 : serie.turmas) !== null && _a !== void 0 ? _a : []).map((turma) => {
        var _a;
        materias.push(...((_a = turma.materias) !== null && _a !== void 0 ? _a : []));
    });
    return materias.filter((m, i, a) => i === a.findIndex((t) => t.id == m.id));
};
exports.getMateriasTreeView = getMateriasTreeView;
